import React, { useEffect, useState } from "react";
import { Card, Col, Nav, Row} from "react-bootstrap";
import Footer from "../layouts/Footer";
import Header from "../layouts/Header";
import { formatDate, truncateText } from "../utils/utilities";
import Spinner1 from "../components/common/spinners";
import useManageLabour from "../hooks/patientDashboard/useManageLabour";
import AppointmentSidebar2 from "../components/common/Recent&Transaction";

export default function LabourHistory() {
  const currentSkin = (localStorage.getItem('skin-mode')) ? 'dark' : '';
  const [skin, setSkin] = useState(currentSkin);
  const {loading, labour, handleFetchLabourHistory} = useManageLabour()

  useEffect(() =>{
    handleFetchLabourHistory()
  }, [])

    const switchSkin = (skin) => {
        if (skin === 'dark') {
        const btnWhite = document.getElementsByClassName('btn-white');

        for (const btn of btnWhite) {
            btn.classList.add('btn-outline-primary');
            btn.classList.remove('btn-white');
        }
        } else {
        const btnOutlinePrimary = document.getElementsByClassName('btn-outline-primary');

        for (const btn of btnOutlinePrimary) {
            btn.classList.remove('btn-outline-primary');
            btn.classList.add('btn-white');
        }
        }
  };

  switchSkin(skin);
  useEffect(() => {
    switchSkin(skin);
  }, [skin]);


 

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <Row>
        <Col>
        <div className="main main-app p-3 p-lg-4">
        <div className="d-md-flex align-items-center justify-content-between mb-4">
          <div>
            <h4 className="main-title my-4 fw-bold">Labour History Overview</h4>
          </div>
        </div>

        <div className={"divider divider-start fw-medium mx-3" }>
            <span>Labour History</span>
        </div> 

        <div className="d-md-flex align-items-center justify-content-between mb-4">
            <div>
                <h4 className="main-title mb-0"></h4>
            </div>
            <div className="d-flex gap-2 mt-3 mt-md-0">
            
            <Nav className="nav-icon nav-icon-sm ms-auto">
                <Nav.Link href="" ><i className="ri-refresh-line text-success"></i></Nav.Link>
                <Nav.Link href=""><i className="ri-more-2-fill"></i></Nav.Link>
            </Nav>
            </div>
    
        </div> 

        <Row className="g-3 ">
            <Col xl="12">
                <Card className="card-one">   


                    <Card.Body className="p-3">
                        <div className="table-responsive mt-3 w-100">
                        
                            {
                            loading ? <div className=' w-100 d-flex justify-content-center '><Spinner1/></div> :
                                // !loading && labour?.result?.length === 0 ? <div className=' w-100 d-flex justify-content-center '><h6>No result found!</h6></div>
                            // :
        
                            <table className="table table-agent mb-0 w-100" style={{ '--bs-table-bg': 'transparent', '--bs-table-color': 'transparent' }}>
                                <thead>
                                <tr>
                                    <th><h6 className="">ID</h6></th>
                                    <th><h6 className="">Date OF Enrollment</h6></th>
                                    
                                    <th><h6 className="">Enrolled By</h6></th>
                                    <th><h6 className="">Date Closed </h6></th>
                                    <th><h6 className="">Closed By </h6></th>
                                    <th><h6 className="">Status </h6></th>
                                    
                                </tr>
                                </thead>

                                {
                                    <tr>
                                        <td colSpan="6" className="text-center">
                                            No result found!
                                        </td>
                                    </tr>
                                

                                /* {
                                    labour?.result?.map((item)=>(
                                    <tbody key={item.id}>
                                    <tr>
                                    <td>

                                        <div className="d-flex align-items-center gap-2">
                                            <div className="avatar border border-2 border-success text-info d-flex justify-content-center align-items-center">
                                                <i class="ri-capsule-fill"></i>
                                            </div>
                                            <div>
                                                <h6 className="mb-0 fs-sm text-danger">
                                                    {truncateText(`${item?.title ?? "---"}`, 30)}
                                                    
                                                </h6>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div>
                                            <h6 className="mb-0 fs-sm text-capitalize">
                                                
                                                {item?.createdBy ?? "---"}
                                            </h6>
                                        </div>
                                    </td>
                                   
                                    <td>
                                        <h6 className="mb-0 fs-sm">
                                            {item?.taskType ?? "---"}
                                        </h6>
                                    </td>
                                    <td>
                                        <h6 className="mb-0 fs-sm text-primary">
                                            {formatDate( item?.nextTime?? "---")}
                                        </h6>
                                    </td>
                                    <td>
                                        <h6 className="mb-0 fs-sm">
                                        {item?.tasksCompleted ?? "---"}/{item?.taskCount ?? "---"}
                                        </h6>
                                    </td>
                                                                    
                                    </tr>
                                    </tbody>
        
                                    ))
                                } */}
                                
                            </table>
        
                            }
                        </div>
                    </Card.Body>
                </Card>
            </Col>
          
        </Row>
        <Footer />
      </div>
        </Col>
        <AppointmentSidebar2/>
      </Row>
    </React.Fragment>
  );
}
